import { STOP_VOLUMES as STOP_VOLUMES_FIELD } from "./";
import { ALL } from "../strings";

const OPTIONS = {
  0: { label: ALL },
  1: {
    label: "0-50",
    functionParameters: { min: 0, max: 50 },
  },
  2: {
    label: "51-100",
    functionParameters: { min: 51, max: 100 },
  },
  3: {
    label: "101-150",
    functionParameters: { min: 101, max: 150 },
  },
  4: {
    label: "151-200",
    functionParameters: { min: 151, max: 200 },
  },
  5: {
    label: "201-250",
    functionParameters: { min: 201, max: 250 },
  },
  6: {
    label: "251+",
    functionParameters: { min: 251, max: 10000000 },
  },
};

export const STOP_VOLUMES = {
  title: "Route Stop Volume",
  field: STOP_VOLUMES_FIELD,
  values: Object.keys(OPTIONS).map((option) => ({
    value: option,
    ...OPTIONS[option],
  })),
  filterCallback: ({ route, min, max }) =>
    route.stops?.length >= min && route.stops?.length <= max,
  volumeOverlayRequired: true,
};
